export function subscribeCurrencyRefresh(refresh) {
  if (typeof window === 'undefined') return () => {};
  const visible = () => {if (document.visibilityState === 'visible') refresh();};
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', visible);
  const timer = window.setInterval(visible, 60000);
  return () => {window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', visible); window.clearInterval(timer);};
}
